import { FC } from "react";
import { InterruptV1SessionPart, ReasoningV1SessionPart, SessionPartKind } from "../session.types";
import styled from "@emotion/styled";
import { MDSSessionPartContainer } from "@/mds/components/sessions/session-parts/session-part.style";
import { SessionPartProps } from "@/mds/components/sessions/session-parts/session-part.types";

type Props = SessionPartProps<ReasoningV1SessionPart | InterruptV1SessionPart>;

export const MDSSessionReasoningV1Part: FC<Props> = ({ part, context }) => {
  const shouldStrikeThrough = (() => {
    if (part.kind === SessionPartKind.InterruptV1) {
      return false;
    }

    return context.isInInterruptedGroup ?? false;
  })();

  return <Container shouldStrikeThrough={shouldStrikeThrough}>{part.summary}</Container>;
};

const Container = styled(MDSSessionPartContainer)<{ shouldStrikeThrough: boolean }>`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  text-decoration: ${({ shouldStrikeThrough }) => (shouldStrikeThrough ? "line-through" : "none")};
`;
